import React from 'react';

import "./ShopMenu.scss";
import { Menu } from '@randajan/jet-react/dom/menu';

import { ShopLink } from './ShopLink/ShopLink';

import { useBeam } from '@randajan/bifrost/client/react';
import { shopBeam, userBeam } from '../../../config/bifrost';

import { Pane } from "@randajan/jet-react/dom/pane";
import tab from "@randajan/jet-react/base/tab";


export const ShopMenu = (props) => {
    const { } = props;

    const [menuVisible] = tab.use("menuVisible");
    const { data: shop } = useBeam(shopBeam);

    console.log(shop);

    return (
        <section className={"ShopMenu"}>
            <Pane position="left" transition={{ enter: 400, exit: 1000 }} expand={shop?.isAuthorized && menuVisible.get()} keepMounted appear>
                {shop?.categories?.sort((a, b)=>{
                    return String.jet.fight(a.name, b.name) == a.name ? -1 : 1;
                }).map(c => <ShopLink key={c.id} {...c} />)}
            </Pane>
        </section>

    )
};

